import Box from "@material-ui/core/esm/Box";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import DividerComponent from 'components/Divider/Divider';
import RouterStepper from 'components/Stepper/RouterStepper';
import { LargeHeader } from 'components/Text';
import { HOME } from 'routes/home/paths';
export default function TransferTagLayout({
  onForwardButtonClick,
  hasForwardButtonDisabled,
  altForwardButtonText,
  children,
  isForwardButtonLoading,
  isFinalStep
}) {
  const {
    t
  } = useTranslation();
  const {
    push
  } = useHistory();
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(LargeHeader, null, t('transfer_tag.transfer_this_tag')), /*#__PURE__*/React.createElement(Box, {
    mb: 3
  }, children), /*#__PURE__*/React.createElement(DividerComponent, null), /*#__PURE__*/React.createElement(RouterStepper, {
    onBackButtonClick: () => push(HOME),
    onForwardButtonClick: onForwardButtonClick,
    hasForwardButtonDisabled: hasForwardButtonDisabled,
    altForwardButtonText: altForwardButtonText,
    isForwardButtonLoading: isForwardButtonLoading,
    isFinalStep: isFinalStep
  }));
}